import { getUserById } from '../api';
import { useAuthStore } from '@/features/Auth/model/authStore';
import { useQuery } from '@tanstack/react-query';
import { userProfileQueryKey } from './queryKeys';

interface UseUserProfileApiParams {
  isEnabled?: boolean;
}

export const useUserProfileApi = (params: UseUserProfileApiParams = {}) => {
  const {
    isEnabled = true
  } = params;
  const userId = useAuthStore((state) => state.tokenData?.user_id ?? null);

  return useQuery({
    enabled: Boolean(userId) && isEnabled,
    queryFn: () => getUserById({ id: userId as string }),
    queryKey: userProfileQueryKey(userId),
    refetchOnWindowFocus: 'always',
    staleTime: 300_000
  });
};